<template>
  <div class="mb-8">
    <h3 class="mb-4 flex items-center text-2xl font-semibold text-ternary-dark dark:text-primary-light">
      <span class="mr-3 text-2xl">{{ emoji }}</span>
      {{ title }}
    </h3>
    <p class="mb-4 leading-relaxed text-gray-600 dark:text-gray-400" v-html="description" />
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div
        v-for="card in cards"
        :key="card.title"
        class="rounded-lg bg-gradient-to-r from-accent/5 to-gradient-end/5 p-4 dark:from-accent/10 dark:to-gradient-end/10"
      >
        <h4 class="mb-2 font-semibold text-accent dark:text-accent">
          {{ card.emoji }} {{ card.title }}
        </h4>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          {{ card.content }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface ExpertiseCard {
  title: string
  emoji: string
  content: string
}

interface Props {
  title: string
  emoji: string
  description: string
  cards: ExpertiseCard[]
}

defineProps<Props>()
</script>
